import styled from '../../utils/styling/styled';
import StaticPageTextLink from '../StaticPageItems/StaticPageTextLink';

export const ComplaintLink = styled(StaticPageTextLink)`
  word-wrap: break-word;
`;
